// @unocss-include
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dialog, DialogContent, H2 } from '@a-type/ui';
import { useMe } from '../hooks/graphql.js';
import { LogoutButton } from './LogoutButton.js';
import { ManagePlanButton } from './ManagePlanButton.js';
export function SubscriptionExpiredDialog({}) {
    var _a, _b;
    const { data } = useMe();
    const isLoggedIn = !!(data === null || data === void 0 ? void 0 : data.me);
    const subscriptionStatus = (_b = (_a = data === null || data === void 0 ? void 0 : data.me) === null || _a === void 0 ? void 0 : _a.plan) === null || _b === void 0 ? void 0 : _b.subscriptionStatus;
    const open = isLoggedIn && subscriptionStatus === 'expired';
    return (_jsx(Dialog, { open: open, children: _jsxs(DialogContent, { children: [_jsx(H2, { children: "Subscription expired" }), _jsx("p", { children: "Looks like you either cancelled your subscription, or your payment didn't go through. To keep using sync, please check your card details." }), _jsx(ManagePlanButton, {}), _jsx("p", { children: "If you intended to cancel your subscription, log out to dismiss this message." }), _jsx(LogoutButton, { children: "Log out" })] }) }));
}
//# sourceMappingURL=SubscriptionExpiredDialog.js.map